import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { IntlProvider } from "react-intl";
import formats from "./formats";
import { loadPolyfillAndData } from "~/intl/intUtils";
import GlobalLoader from "../components/GlobalLoader";

function ReduxIntl({ locale, messages, children }) {
  const [localeLoaded, setLocaleLoaded] = useState(null);
  useEffect(() => {
    loadPolyfillAndData(locale).then(() => setLocaleLoaded(locale));
  }, [locale]);

  if (!localeLoaded) {
    return <GlobalLoader />;
  }

  return (
    <IntlProvider formats={formats} locale={localeLoaded} messages={messages}>
      {children}
    </IntlProvider>
  );
}

ReduxIntl.propTypes = {
  locale: PropTypes.string.isRequired,
  messages: PropTypes.object.isRequired,
  children: PropTypes.node,
};

const mapStateToProps = ({
  intl: { locale = "en", messages = {}, isLoading = false } = {},
} = {}) => {
  return {
    locale,
    messages,
  };
};

export default connect(mapStateToProps)(ReduxIntl);
